import {
  IGeocode,
  IPOISearch,
  IResult,
  IRoutePlan,
  IRoadNetwork,
  IJurisdiction, IReverseGeocode, IPOISearchPGIS
} from '@/types/map';

export default class webAPIRequestPGIS {
  public static fmap: any;
  constructor() { }

  public static async requestPOI(params: IPOISearchPGIS): Promise<any> {
    //搜索兴趣点图层
    const searchLayers = params.searchLayer?.length ? params.searchLayer : '';
    const orgCode = params.orgCode ? params.orgCode.toString() : '513400000000';
    const keyWords = params.searchName || '';
    const searchPage = params.searchPage || 0;
    const searchSize = params.searchSize || 20;
    const searchShapeType = params.searchType || '';
    const searchCoords = params.searchCoords || '';

    const queryOption = {
      searchLayers,
      orgCode,
      keyWords,
      pager: {
        pageSize: searchSize,
        pageIndex: searchPage
      }
    }

    const spaceOption = {
      shapeType: searchShapeType,
      coordinate: searchCoords
    }

    const promise = new Promise(resolve => {
      this.fmap.queryResource(queryOption, spaceOption, function (results: any) {
        resolve(results);
      })
    })

    return promise
  }

  public static async requestJurisdictionData(params: IJurisdiction): Promise<any> {
    const orgCode = params.orgCode;

    const promise = new Promise(resolve => {
      this.fmap.getOrgInfo(orgCode, function (results: any) {
        resolve(results);
      })
    })

    return promise;
  }

  public static async requestJurisdictionBoundary(params: IJurisdiction): Promise<any> {
    const orgCode = params.orgCode.toString();
    const promise = new Promise(resolve => {
      this.fmap.getAreaCoord(orgCode, function (results: any) {
        resolve(results);
      })
    })

    return promise;
  }

  public static async requestSubJurisdiction(params: IJurisdiction): Promise<any> {
    const orgCode = params.orgCode.toString();
    const options = {
      orgCode
    }
    const promise = new Promise(resolve => {
      this.fmap.getSubsidiaries(options, function (results: any) {
        resolve(results);
      })
    })
    return promise;
  }

  public static async requestRoadPlan(params: IRoutePlan): Promise<IResult> {

    return {
      status: 0,
      message: 'not complete!'
    }
  }

  public static async requestGeocode(params: IGeocode): Promise<any> {
    const address = params.address;

    const promise = new Promise(resolve => {
      this.fmap.geocode(address, function (results: any) {
        resolve(results);
      })
    })

    return promise;
  }

  public static async requestReverseGeocode(params: IReverseGeocode): Promise<any> {
    const location = params.location;
    const buffer = params.buffer || 100;
    // const isExtendBuffer = params.isExtendBuffer || false;
    // const secondBuffer = params.bufferSecond || undefined;
    // const thirdBuffer = params.bufferThird || undefined;
    const pageIndex = params.pageIndex || 0;
    const pageSize = params.pageSize || 30;

    const option = {
      buffer,
      // isExtendBuffer,
      // secondBuffer,
      // thirdBuffer,
      pageIndex,
      pageSize
    }

    const promise = new Promise(resolve => {
      this.fmap.reverseGeocode(location, option, function (results: any) {
        resolve(results);
      })
    })

    return promise
  }
}